<template>
  <!-- The overlay -->
  <div id="myNav" class="overlay">
    <!-- Button to close the overlay navigation -->
    <a href="javascript:void(0)" class="closebtn" onclick="closeNav()"
      >&times;</a
    >
    <!-- Overlay content -->
    <div class="overlay-content">
      <login-view v-if="displayModal == 'login'"></login-view>
      <signup-view v-else-if="displayModal == 'signup'" @change-page="changeOption"></signup-view>
      <signup-vendor v-else></signup-vendor>
    </div>
  </div>
</template>
<script>
import LoginView from '../partials/Login.vue'
import SignupView from '../partials/Signup.vue'
import SignupVendor from '../partials/SignupVendor.vue'
export default {
  props: ['displayModal'],
  components: {
    LoginView,
    SignupView,
    SignupVendor
  },
  data() {
    return {}
  },
  methods: {
    changeOption (value) {
      this.$emit('modal-option', value)
    }
  }
}
</script>
